import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=1bf9e492&scoped=true"
import script from "./tab3.vue?vue&type=script&lang=js"
export * from "./tab3.vue?vue&type=script&lang=js"
import style0 from "./tab3.vue?vue&type=style&index=0&id=1bf9e492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9e492",
  null
  
)

export default component.exports